import { Modal, useOverlayState, type OverlayTriggerState } from '@heroui/react';

interface ImageLightboxProps {
  state: OverlayTriggerState;
  src: string;
  alt: string;
}

function ImageLightbox({ state, src, alt }: ImageLightboxProps) {
  return (
    <Modal state={state}>
      <Modal.Backdrop isDismissable className="z-[400] bg-black/80">
        <Modal.Container placement="center" className="z-[400] p-3 sm:p-6">
          <Modal.Dialog className="max-h-[92vh] w-[min(96vw,56rem)] overflow-hidden border-0 bg-transparent p-0 shadow-none">
            <div className="relative">
              <Modal.CloseTrigger className="absolute right-2 top-2 z-10 rounded-full bg-black/50 text-white" />
              <img
                src={src}
                alt={alt}
                className="max-h-[88vh] w-full rounded-xl object-contain"
              />
            </div>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}

interface ExpandableImageProps {
  src: string;
  alt: string;
  className?: string;
}

export function ExpandableImage({ src, alt, className }: ExpandableImageProps) {
  const lightbox = useOverlayState();

  return (
    <>
      <button
        type="button"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          lightbox.open();
        }}
        className="block w-full cursor-zoom-in rounded-xl text-left"
        aria-label="Ver foto em tamanho grande"
      >
        <img src={src} alt={alt} className={className} />
      </button>
      <ImageLightbox state={lightbox} src={src} alt={alt} />
    </>
  );
}
